import "./product-form";
import "./pdp-tabs";
import "./product-media.jsx";
import VariantPicker from "./variant-picker.jsx";
import { h, render } from "preact";
import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";
import "./product-details-drawer";
import "./item-count";
import "./product-video";
import "./pdp-slideshow";
import "./estimated-delivery/estimated-delivery.jsx";
import "./popular-addons/popular-addons.jsx";
import "./bundle-configurator/bundle-configurator.jsx";
import "./find-certified-guide/find-certified-guide.jsx";

class SectionProduct extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.container = this.querySelector("[data-variant-picker-container]");

    this.group = this.data.product.tags?.find((t) => t.includes("group:"));
    this.groupSet = {};

    this.getProductGroup();
  }

  getProductGroup = async () => {
    if (!this.group) this.init();
    if (!this.group) return;
    const response = await storefront.request({
      query: queries.productsByTag(this.group),
    });
    if (response?.data?.products) {
      const products = response.data.products.edges.filter((p) => p);
      let productsClean = products.map((p) => p.node?.variants?.edges[0]),
        productOptions = productsClean.map((p) => p.node?.selectedOptions[0]);
      if (!productsClean) return;
      this.groupSet["products"] = products;
      this.groupSet["options"] = productOptions;

      this.init();
    }
  };

  init = async () => {
    if (!this.data.product) return;

    const response = await storefront.request({
      query: queries.product,
      variables: {
        handle: this.data.product.handle,
      },
    });

    const VariantPickerComponent = () => {
      return (
        <VariantPicker
          data={this.data}
          product={response.data.productByHandle}
          form={this.closest("product-form")}
          group={this.groupSet}
        />
      );
    };

    this.container && render(<VariantPickerComponent />, this.container);
  };
}

if (!customElements.get("section-product")) {
  customElements.define("section-product", SectionProduct);
}
